/* eslint-disable max-len */
import React from 'react';
import { AllieIconProps } from '../../../components';

export const MoreVertIcon: React.FC<AllieIconProps> = ({
  allieColor = 'var(--allie-color-neutral-60)',
}) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 12.5C12.2761 12.5 12.5 12.2761 12.5 12C12.5 11.7239 12.2761 11.5 12 11.5C11.7239 11.5 11.5 11.7239 11.5 12C11.5 12.2761 11.7239 12.5 12 12.5Z"
        fill={allieColor}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 12.25C12.1381 12.25 12.25 12.1381 12.25 12C12.25 11.8619 12.1381 11.75 12 11.75C11.8619 11.75 11.75 11.8619 11.75 12C11.75 12.1381 11.8619 12.25 12 12.25ZM10.75 12C10.75 11.3096 11.3096 10.75 12 10.75C12.6904 10.75 13.25 11.3096 13.25 12C13.25 12.6904 12.6904 13.25 12 13.25C11.3096 13.25 10.75 12.6904 10.75 12Z"
        fill={allieColor}
      />
      <path
        d="M12 18.5C12.2761 18.5 12.5 18.2761 12.5 18C12.5 17.7239 12.2761 17.5 12 17.5C11.7239 17.5 11.5 17.7239 11.5 18C11.5 18.2761 11.7239 18.5 12 18.5Z"
        fill={allieColor}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 18.25C12.1381 18.25 12.25 18.1381 12.25 18C12.25 17.8619 12.1381 17.75 12 17.75C11.8619 17.75 11.75 17.8619 11.75 18C11.75 18.1381 11.8619 18.25 12 18.25ZM10.75 18C10.75 17.3096 11.3096 16.75 12 16.75C12.6904 16.75 13.25 17.3096 13.25 18C13.25 18.6904 12.6904 19.25 12 19.25C11.3096 19.25 10.75 18.6904 10.75 18Z"
        fill={allieColor}
      />
      <path
        d="M12 6.5C12.2761 6.5 12.5 6.27614 12.5 6C12.5 5.72386 12.2761 5.5 12 5.5C11.7239 5.5 11.5 5.72386 11.5 6C11.5 6.27614 11.7239 6.5 12 6.5Z"
        fill={allieColor}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 6.25C12.1381 6.25 12.25 6.13807 12.25 6C12.25 5.86193 12.1381 5.75 12 5.75C11.8619 5.75 11.75 5.86193 11.75 6C11.75 6.13807 11.8619 6.25 12 6.25ZM10.75 6C10.75 5.30964 11.3096 4.75 12 4.75C12.6904 4.75 13.25 5.30964 13.25 6C13.25 6.69036 12.6904 7.25 12 7.25C11.3096 7.25 10.75 6.69036 10.75 6Z"
        fill={allieColor}
      />
    </svg>
  );
};
